  <button mat-icon-button class="dialog-close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>

<h2 mat-dialog-title class="modal-title">Add New Client</h2>
  <form [formGroup]="billingForm" (ngSubmit)="onSubmitNewClient()">


<mat-dialog-content class="form-grid">

  <!-- Row 1 — full width -->


  <div class="form-item full-width">

      <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Client Name</mat-label>
      <input matInput formControlName="clientName" />
      <mat-error *ngIf="f['clientName'].hasError('required')">
      This field is required
    </mat-error>
    </mat-form-field>
 
  </div>

  <!-- Row 1 Column 2 -->
  <div class="form-item">
    <app-data-picker
  [label]="'Registration Date'"
  [form]="billingForm"
  controlName="registrationDate"
  [maxDate]="today">
</app-data-picker>


  </div>

  
    <div class="form-item">
  <mat-form-field appearance="outline" class="form-field full-width">
    <mat-label>License Limit</mat-label>
    <input matInput formControlName="activeEmployees" type="text" inputmode="numeric" />
  <mat-error *ngIf="f['activeEmployees'].hasError('required')">
  This field is required
</mat-error>
<mat-error *ngIf="f['activeEmployees'].hasError('pattern')">
  Please enter a valid number
</mat-error>
<mat-error *ngIf="f['activeEmployees'].hasError('min')">
  Minimum value is 1
</mat-error>
<mat-error *ngIf="f['activeEmployees'].hasError('max')">
 License Limit cannot exceed 1,000,000
</mat-error>
  </mat-form-field>
</div>

 
  

  <!-- Row 3 -->
  <div class="form-item">
    <app-input-dropdown
      [label]="'Branch'"
      [formGroup]="billingForm"
      controlName="branch"
      [options]="branches"
      (selectionChange)="onCategorySelect($event)">
    </app-input-dropdown>
  </div>

  <!-- Conditional dropdown shown only when Branch === 'OTHER' -->
  <div class="form-item" *ngIf="isBranchOther()">
    <app-input-dropdown
      [label]="'Client Specific Branch'"
      [formGroup]="billingForm"
      controlName="condition"
      [options]="conditionOptions"
      (selectionChange)="onConditionSelect($event)">
    </app-input-dropdown>
  </div>
  <div class="form-item">

      <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Fin Number</mat-label>
      <input matInput formControlName="finNumber" maxlength="6" />
      <mat-error *ngIf="f['finNumber'].hasError('required')">
        This field is required
      </mat-error>
      <mat-error *ngIf="f['finNumber'].hasError('pattern') || f['finNumber'].hasError('minlength') || f['finNumber'].hasError('maxlength')">
        Financial number must be 6 alphanumeric characters 
      </mat-error>
    </mat-form-field>
 
  </div>
<!-- Checkbox -->
<!-- Override Theme checkbox -->
<app-checkboxes
  label="Override Theme"
  [checkboxes]="overrideThemeOptions"
  (selectionChange)="onOverrideThemeChange($event)">
</app-checkboxes>

<!-- Platform Enabled checkbox -->
<app-checkboxes
  label="Platform Enabled"
  [checkboxes]="platformEnabledOptions"
  (selectionChange)="onPlatformEnabledChange($event)">
</app-checkboxes>

<!-- Dropdown when override is TRUE -->
<div class="form-item" *ngIf="billingForm.get('companyTheme')?.value">
  <app-input-dropdown
    [label]="'Theme Name'"
    [formGroup]="billingForm"
    controlName="themeNameNew"
    [options]="themeNameOptions"
    (selectionChange)="onThemeSelect($event)">
  </app-input-dropdown>
</div>

<!-- Read-only when override FALSE -->
<div class="form-item" *ngIf="!billingForm.get('companyTheme')?.value">
  <app-lbn-input-field
    [formGroup]="billingForm"
    label="Theme Name"
    controlName="themeName"
    [disabled]="true">
  </app-lbn-input-field>
</div>

</mat-dialog-content>




 <mat-dialog-actions align="end" class="dialog-actions">
  <app-form-actions-buttons [buttons]="updateButtons"></app-form-actions-buttons>
</mat-dialog-actions> 
</form>